export const LangEn = {
    name:'en',
    data:{
        "login": {
            "or": "or",
            "googleRefused": "This Google account has no access to Jobbiz administration.",
            "googleFailed": "Google sign-in failed. Try again or use your password.",
            "googleUnavailable": "Google sign-in is unavailable. Use your password."
        },
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        map : new Map()
    }
}